const LIVE: string[] = [
  'News, stories and editorial features',
  'Tournament calendar and event detail pages',
  'Community bulletin board and submissions',
  'Sponsorship packages and enquiry form',
];

const PLANNED: string[] = [
  'Automated tournament discovery from public sources',
  'AI-drafted community bulletins and newsletters',
  'Sponsor inquiry triage and reply suggestions',
  'Editor approval queue for every draft',
];

export default function LiveVsPlanned() {
  return (
    <section className="bg-foreground-950 px-4 md:px-8 py-16 md:py-24">
      <p className="font-label uppercase tracking-[0.28em] text-xs text-accent-400 font-semibold">Honest scorecard</p>
      <h2 className="font-heading font-bold text-4xl md:text-6xl text-background-50 leading-[1.02] mt-3">What&apos;s live today vs. what&apos;s still a concept</h2>
      <div className="mt-10 grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="rounded-lg border border-primary-700 bg-primary-800 p-6 md:p-8">
          <div className="flex items-center gap-3">
            <span className="w-9 h-9 rounded-md bg-accent-500 text-foreground-950 flex items-center justify-center text-xl"><i className="ri-checkbox-circle-line"></i></span>
            <h3 className="font-heading font-bold text-2xl text-background-50">Live today</h3>
          </div>
          <ul className="mt-6 space-y-3">
            {LIVE.map((t) => (
              <li key={t} className="flex items-start gap-3 text-sm text-background-100">
                <span className="w-5 h-5 flex items-center justify-center text-accent-400 shrink-0 mt-0.5"><i className="ri-check-line"></i></span>
                {t}
              </li>
            ))}
          </ul>
        </div>
        <div className="rounded-lg border border-foreground-700 bg-foreground-900 p-6 md:p-8">
          <div className="flex items-center gap-3">
            <span className="w-9 h-9 rounded-md bg-secondary-500 text-foreground-950 flex items-center justify-center text-xl"><i className="ri-flask-line"></i></span>
            <h3 className="font-heading font-bold text-2xl text-background-50">Planned &mdash; concept only</h3>
          </div>
          <ul className="mt-6 space-y-3">
            {PLANNED.map((t) => (
              <li key={t} className="flex items-start gap-3 text-sm text-background-200">
                <span className="w-5 h-5 flex items-center justify-center text-secondary-400 shrink-0 mt-0.5"><i className="ri-subtract-line"></i></span>
                {t}
              </li>
            ))}
          </ul>
          <p className="mt-6 text-xs text-background-300">No agents, databases, APIs or background jobs are running today.</p>
        </div>
      </div>
    </section>
  );
}